<arm-layout [summaryTitle]=summaryTitle>
  <div header>
    <div class="search-container">
      <arm-search (onSearch)="onSearch($event)"
                  [searchComponent]="alarmsSearchComponent"
                  [searchData]="searchData"
                  [searchTerms]="searchTerms">
      </arm-search>
    </div>

    <div class="action-buttons">
      <arm-action-bar (refreshClick)="refresh(true)"></arm-action-bar>

      <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
        <span>Actions</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button (click)="toggleAutoRefresh()" mat-menu-item>
          <i class="fa" [ngClass]="{'fa-stop-circle': isAutoRefreshActivated, 'fa-play-circle': !isAutoRefreshActivated}"></i>
          <span>{{generateAutoRefreshName()}}</span>
        </button>

        <button *ngIf="type === 'active'" (click)="acknowledgeAlarm()" mat-menu-item [disabled]="isUnauthorized || selection.length === 0">
          <span>Acknowledge</span>
        </button>

        <button (click)="openColumnsConfiguration()" mat-menu-item>
          <span>Table columns</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div summary>
   <alarms-summary [selection]="selection" [type]="type">
    </alarms-summary>
  </div>

  <div main>
    <arm-table [displayedColumns]="displayedColumns" [data]="data"
               (onSelection)="onSelection($event)" [isMultipleSelection]="true"
               [isCursorPageTable]="true"  [isPagedTable]="false"
               [pageEventCursor]="pageEventCursor" (pageChangedCursor)="pageChanged($event)"></arm-table>
  </div>
</arm-layout>

